import AbsComponent from '../../common/components/AbsComponent';
import ServerfilterTempl from './ServerfilterTempl';

/**
 * Sub1 class
 * @category testApp
 */
class Serverfilter extends AbsComponent{
    constructor(_store={}){
        super(_store);
        this.store.getServerInfoData(this.render.bind(this));
    }

    render(_jsonData = {}){
        $(this.el +' #select-serverId').append(ServerfilterTempl.getServerFilterTempl(_jsonData));
        this.addEvents();
    }

    addEvents(){
        $(document).on('change', '#select-serverId', (e)=>{
            let select_name = $(e.currentTarget).children("option:selected").text();
            let server_type = $(e.currentTarget).children("option:selected").attr('data-server-type');
            let label_object = $(e.currentTarget).parent("label");
            let select_object = $(e.currentTarget);
            label_object.text(select_name);
            label_object.append(select_object);

            $('#select-serverId').trigger('server_change', {serverType:server_type});
            $('#select-serverId').trigger('result_change');
        });
    }
}

export default Serverfilter;